import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import analytics from "services/analytics";

export const useAnalytics = (): void => {
  const location = useLocation();
  const prevLocation = useRef<typeof location | null>(null);

  useEffect(() => {
    // Page leave event for PostHog
    if (
      prevLocation.current &&
      prevLocation.current.pathname !== location.pathname
    ) {
      analytics().sendPageleavePosthog(
        prevLocation.current.pathname + prevLocation.current.search
      );
    }

    // Page view event for Google Analytics and PostHog
    const currentPath = location.pathname + location.search;
    analytics().sendPageview(currentPath);

    prevLocation.current = location;
  }, [location]);
};

export default useAnalytics;
